import { render, staticRenderFns } from "./StocksCard.vue?vue&type=template&id=6b1b01fe&"
import script from "./StocksCard.vue?vue&type=script&lang=js&"
export * from "./StocksCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports